// | ------------------------------------------------------------------------
// | Home Carousels
// | ------------------------------------------------------------------------ 

import Splide from '@splidejs/splide'; //? https://splidejs.com/

document.addEventListener( 'DOMContentLoaded', function () {

	var homeCarousel = document.querySelector('.home-content-carousel');

	if (homeCarousel){
	
		var homeContentCarousel = new Splide( '.home-content-carousel', {
			type: 'fade',
			rewind: true,
			perPage: 1,
			perMove: 1,
			cover: true,
			pauseOnHover: true,
			isNavigation: false,
			pagination: false,
		}).mount();
		
		var homeImageCarousel = new Splide( '.home-image-carousel', {
			type: 'loop',
			autoplay: true,
			interval: 4000,
			pauseOnHover: true,
			//type       : 'fade',
			pagination : false,
			arrows     : false,
			cover      : true,
		});
		
		homeImageCarousel.sync( homeContentCarousel ).mount();

	}

});